import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import {
	acriss,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	prepaid,
	priceKpi,
	providers,
	reports,
	searchID,
	sites,
	transmission
} from "@signals"
import { dorSchema } from "../schema"
import { useToast } from "@hooks"
import { analyzerFilters, isAnalyzerLoading, resetSignals, responseData, tableHasMainComparison, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { useValidatorSeeker } from "@ui-seeker/app"
import { dorPayload } from "Pages/AnalyzersV2/Dor/@signals"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerDorFilters() {
	const { showToast } = useToast()
	const { isValid, errors } = useValidatorSeeker(dorPayload.value, dorSchema(searchID.value))

	const onSubmit = useCallback((clearTab = false) => batch(() => {
		isAnalyzerLoading.value = true
		responseData.value = {}
		resetSignals(clearTab)
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		postSubmit("/api/dashboard/results", dorPayload.value).then(res => {
			batch(() => {
				responseData.value = { ...res, type: SECTIONS.DOR }
				analyzerFilters.value = res.filters
				isAnalyzerLoading.value = false
			})
		}).catch(() => {
			isAnalyzerLoading.value = false
			showToast.error()
		})
	}), [
		currency.value, offices.value, tableTabSelected.value, acriss.value,
		transmission.value, categories.value, fuelPolicy.value, lengthRental.value,
		providers.value, prepaid.value, mileage.value, priceKpi.value, inTerminal.value,
		insurance.value, includeProviders.value, sites.value, reports.value, isValid
	])

	return {
		onSubmit: onSubmit,
		isValid: (isValid && !!reports.value) || !!searchID.value,
		errors: errors
	}
}